import React, { useEffect } from 'react'
import './NewTestimonial.css'
import Slider from "react-slick";
import { useRef, useState } from "react";
import HomeService from '../../../Services/HomeService';

const testimonials_tm = [
  {
    name: "Priya Sharma",
    role: "Real Estate Investor",
    image: "https://authordianeward.com/wp-content/uploads/2024/04/Smiling-Woman-at-a-Picnic-Table-6rvont0umftblyge0xcth9bifsib3si993f9m7bswq2.jpg",
    text:
      "The Winners platform made my property search incredibly easy. I found my dream apartment within weeks. The team is responsive and knowledgeable."
  },
  {
    name: "Ankit Verma",
    role: "Home Buyer",
    image: "https://t3.ftcdn.net/jpg/06/50/56/80/360_F_650568058_q6KruAvlT4w7RahAGwIwgIY8ZjIkGAYg.jpg",
    text:
      "A seamless experience from start to finish. Highly recommended for anyone looking to invest in property."
  },
  {
    name: "Neha Kapoor",
    role: "Property Consultant",
    image: "https://www.shutterstock.com/image-photo/portrait-female-owner-gift-store-260nw-1688925892.jpg",
    text:
      "Professional, transparent, and extremely user-friendly. One of the best platforms in the market."
  }
];


const NewTestimonial = () => {
 const [index, setIndex] = useState(0);
 const [testimonials,setTestimonials]=useState([])
 const intervalRef=useRef(null)
 const autoDelay=2000

//   const prevHandler = () => {
//     setIndex((prev) => (prev === 0 ? testimonials_tm.length - 1 : prev - 1));
//   };

//   const nextHandler = () => {
//     setIndex((prev) => (prev === testimonials_tm.length - 1 ? 0 : prev + 1));
//   };

  const fetchTestimonials=async()=>{
     try {
        const res=await HomeService?.getTestimonial();
        console.log('testi',res);
        if(res?.status){
            setTestimonials(res?.data)
        }else{
            console.log(res);
        }
     } catch (error) {
        console.log(error);
     }
  }
 useEffect(()=>{
    fetchTestimonials()
 },[])
 console.log("monials",testimonials);

 const startAutoPlay=()=>{
    if(intervalRef.current || testimonials.length===0) return

    intervalRef.current=setInterval(()=>{
        setIndex((prev)=>
          prev===testimonials.length-1? 0 :prev+1
        )
    },autoDelay)
 }
 
 const stopAutoPlay=()=>{
    clearInterval(intervalRef.current)
    intervalRef.current=null
 }

 const resetAutoPlay=()=>{
     stopAutoPlay()
     startAutoPlay()
 }

 useEffect(()=>{
    startAutoPlay()
    return ()=>stopAutoPlay()
 },[testimonials])

  const prevHandler=()=>{
    resetAutoPlay()
    setIndex((prev)=>
      prev===0 ?testimonials.length-1:prev-1
    )
  }
 
   const nextHandler=()=>{
      resetAutoPlay()
      setIndex((prev)=>
        prev===testimonials.length-1? 0 :prev+1
      )
   }

  return (
    <section className="testimonial_section_tm">
        <div className='testimonial_section_cont_tm'>
            <h4 className='testi_heading'>What People Are Saying</h4>
            <div className="testimonial_card_tm"
              onMouseEnter={stopAutoPlay}
              onMouseLeave={startAutoPlay}
            >

               
                <div className="testimonial_image_tm fade_tm">
                    {testimonials?.length>0 && testimonials[index] && (
                        <img src={testimonials[index].image} alt="user" />
                    )}
                
                <div className="testimonial_overlay_tm">
                    <div className='stars_tm'>
                    {Array.from({length:5}).map((_,i)=>(
                        <i key={i} class="fa-solid fa-star"></i>
                    ))}
                    </div>
                    {testimonials?.length>0 && testimonials[index] && (
                        <h4>{testimonials[index].name}</h4>
                    )}
                    
                    {testimonials?.length>0 && testimonials[index] && (
                        <span>{testimonials[index].designation}</span>
                    )}
                    
                </div>
                </div>

            
                <div className="testimonial_content_tm fade_tm">
                <span className="quote_icon_tm">“</span>
                {testimonials?.length>0 && testimonials[index] && (
                    <p>
                
                        {`"${testimonials[index].heading}"`}
                    
                    </p>
                )}
                

                
                <div className="testimonial_controls_tm">
                    <button onClick={prevHandler}>
                    <i className="fa-solid fa-chevron-left"></i>
                    </button>

                    {/* PROGRESS LINE */}
                    <div className="testimonial_progress_tm">
                    <span
                        style={{
                        width:`${100/testimonials.length}%`,
                        transform: `translateX(${index * 100}%)`
                        }}
                    ></span>
                    </div>

                    <button onClick={nextHandler}>
                    <i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
                </div>

            </div>
        </div>
      
    </section>
  );
}

export default NewTestimonial